export enum SurchargeCategory {
  BasePrice = 'base-price',
  CustomDiscountExpense = 'custom-discount-expense',
  Structure = 'structure',
  DoorsAndWindows = 'doors-and-windows',
  AddOns = 'add-ons',
  Services = 'services',
  Subtotal = 'subtotal',
  None = 'none',
}
